import React from 'react';
import CertificateDetailTemplate from './CertificateDetailTemplate';
import guviImage from '../../../assets/images/GUVI  Image.png';

const certificates = [
  {
    title: 'ChatGPT For Everyone',
    issuedBy: 'GUVI',
    date: '22 Aug 2024',
    image: guviImage,
    link: 'https://drive.google.com/file/d/1C1HWuBlOEX7UbWHWDkmYHtBnppe2rWQ7/view?usp=drive_link'
  }
];

const GuviCertificates = () => {
  return (
    <CertificateDetailTemplate
      provider="GUVI"
      certificates={certificates}
    />
  );
};

export default GuviCertificates;
